module.exports = __webpack_public_path__ + "static/media/lebron.f72fec00.png";